import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
    var capabilityPrefix = ApplicationFeatures.getAllFeatures().gatewayendorsement === 'true' ? 'gateway' : '';

    return {
        loadRenewal: function loadRenewal(jobNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'retrieve', [jobNumber]);
        },

        saveRenewal: function saveRenewal(model) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'updateDraftRenewal', [model]);
        },

        updateCoverages: function updateCoverages(jobNumber, lobCoverages) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'updateCoverages', [jobNumber, lobCoverages]);
        },

        generateQuote: function generateQuote(model) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'quote', [model]);
        },

        isQuoted: function isQuoted(jobNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'isQuoted', [jobNumber]);
        },

        retrievePaymentPlans: function retrievePaymentPlans(jobNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'retrievePaymentPlans', [jobNumber]);
        },

        bind: function bind(model) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'bind', [model]);
        },

        updatePaymentPlan: function updatePaymentPlan(model) {
            return JsonRPCService.send('pc', capabilityPrefix + 'renewal/renewal', 'updatePaymentPlan', [model]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-renewal-angular/services/RenewalService.js
// module id = 1874
// module chunks = 0